import React from "react";
import { filterQuotaRounds, isRoundOpen } from "./quotaRounds";

/**
 * รายการรอบแบบข้อความ — ใช้กับประเภทที่ยังไม่มีปุ่มรูปภาพ (บัณฑิตศึกษา)
 * ข้อมูลมาจาก FrontEnd_Admission /admissionnew2022/showrobregister/{param}
 *
 * quotaIds        แสดงเฉพาะ QUOTA_ID เหล่านี้ (ไม่ส่ง = ไม่กรอง)
 * excludeQuotaIds ซ่อน QUOTA_ID เหล่านี้
 * respectStatus   false = เลือกได้ทุกรอบโดยไม่ดู ROB_STATUS
 */
function QuotaRoundList({
  rounds,
  quotaIds,
  excludeQuotaIds,
  respectStatus = true,
  selectedRobId,
  onSelect,
}) {
  const list = filterQuotaRounds(rounds, { quotaIds, excludeQuotaIds });

  if (list.length === 0) {
    return <p className="reg-empty">ยังไม่มีรอบเปิดสมัครเรียน</p>;
  }

  return (
    <ul className="reg-list">
      {list.map((round) => {
        const open = isRoundOpen(round, respectStatus);
        const selected = String(selectedRobId) === String(round.ROB_ID);
        return (
          <li
            key={round.ROB_ID}
            className={`reg-list__item${selected ? " is-selected" : ""}`}
          >
            <div className="reg-list__meta">
              {round.QUOTA_NAME} {round.ROB_NAME}
              <br />
              เปิดตั้งแต่ {round.startdate} ถึง {round.stopdate}
            </div>
            <a
              className={`reg-list__action${open ? "" : " is-closed"}`}
              name="robId"
              id={round.ROB_ID}
              onClick={open ? onSelect : undefined}
              href="#select-rob"
            >
              {open ? "เลือกรอบนี้" : "ปิดรับสมัคร"}
            </a>
          </li>
        );
      })}
    </ul>
  );
}

export default QuotaRoundList;
